import { Injectable } from '@angular/core';
import { Models } from '@ibexfusion/models';

import { RestProvider, RestService } from '../rest/rest.service';
import { RestfulService } from '../rest/restful';

@Injectable()
export class PackageInstalledAppsService extends RestfulService<Models.PackageInstalledApp> {

  constructor(private restService: RestService) {
    super(Models.PackageInstalledApp);
    super.init();
  }

  public createProvider(): RestProvider {
    return this.restService.createProvider('package-installed-apps');
  }

}
